var AlignmentTypes;
(function (AlignmentTypes) {
    AlignmentTypes["LEFT"] = "left";
    AlignmentTypes["RIGHT"] = "right";
    AlignmentTypes["CENTER"] = "center";
    AlignmentTypes["FULL_WIDTH"] = "fullWidth";
    AlignmentTypes["NONE"] = "none";
})(AlignmentTypes || (AlignmentTypes = {}));

export { AlignmentTypes };
